var validatePesel = function validatePesel(pesel) {
  var reg = /^[0-9]{11}$/;
  if (reg.test(pesel) === false) {
    return false;
  } else {
    var dig = ('' + pesel).split('');
    var kontrola = (parseInt(dig[0]) + 3 * parseInt(dig[1]) + 7 * parseInt(dig[2]) + 9 * parseInt(dig[3]) + parseInt(dig[4]) + 3 * parseInt(dig[5]) + 7 * parseInt(dig[6]) + 9 * parseInt(dig[7]) + parseInt(dig[8]) + 3 * parseInt(dig[9])) % 10;
    if (kontrola == 0) {
      kontrola = 10;
    }
    kontrola = 10 - kontrola;
    return parseInt(dig[10]) == kontrola;
  }
};
var calculateBirthdayFromPesel = function calculateBirthdayFromPesel(pesel) {
  var dig = "".concat(pesel).split('');
  var day = dig[4] + dig[5];
  var month = parseInt(dig[2] + dig[3]);
  var year = parseInt(dig[0] + dig[1]);
  var decade = '19';
  if (month > 12 && month < 40) {
    decade = '20';
    month = month - 20;
  }
  if (month > 40 && month < 60) {
    decade = '21';
    month = month - 40;
  }
  if (month > 60 && month < 80) {
    decade = '22';
    month = month - 60;
  }
  if (month > 80 && month < 100) {
    decade = '18';
    month = month - 80;
  }
  if (month < 10) {
    month = '0' + month;
  }
  if (year < 10) {
    year = '0' + year;
  }
  year = decade + year;
  return year + '-' + month + '-' + day;
};
var calculateGenderFromPesel = function calculateGenderFromPesel(pesel) {
  return ['1', '3', '5', '7', '9'].includes(pesel.charAt(9)) ? 'MALE' : 'FEMALE';
};
var convertCentimetersToImperialUnits = function convertCentimetersToImperialUnits(centimeters) {
  var nearExact = centimeters * 0.3937 / 12;
  var ft = Math.floor(nearExact);
  var inches = Math.round((nearExact - ft) * 12 * 100) / 100;
  return {
    ft: ft,
    inches: inches
  };
};
var convertKilosToImperialUnits = function convertKilosToImperialUnits(kilos) {
  var nearExact = kilos / 0.45359237;
  var lb = Math.floor(nearExact);
  var oz = Math.round((nearExact - lb) * 16 * 100) / 100;
  return {
    lb: lb,
    oz: oz
  };
};

export { calculateBirthdayFromPesel, calculateGenderFromPesel, convertCentimetersToImperialUnits, convertKilosToImperialUnits, validatePesel };



//////////////////
// WEBPACK FOOTER
// ./~/braster-frontend-utils/dist/index.esm.js
// module id = 142
// module chunks = 0